module.exports = require("./lt.d.ts");